export default function useValidFileFormat() {
    const validateFormat = <TSuccess, TError>(fileList: FileList | null, callback: (validFiles: File[]) => TSuccess | undefined, errorCallback?: () => TError) => {
        if (!fileList || fileList.length === 0) {
            return;
        }
        const files = Array.from(fileList);

        const excludedExtensions = ['dmg', 'exe'];
        const validFiles = files.filter((file) => {
            const extension = file.name.split('.').pop()?.toLowerCase();

            return extension && !excludedExtensions.includes(extension);
        });

        if (validFiles.length !== files.length) {
            useToasteoError('app.files_extension_upload_not_allowed');
            if (errorCallback) {
                errorCallback();
            }

            return;
        }

        callback(validFiles);
    };
    return { validateFormat };
}
